/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ApisStatusEnum {
  COMPLETE = 'COMPLETE',
  AGENT_REVAL_REQUIRED = 'AGENT_REVAL_REQUIRED',
  NOT_REQUIRED = 'NOT_REQUIRED',
  NOT_PERFORMED = 'NOT_PERFORMED',
  NOT_COMPLETE = 'NOT_COMPLETE'
}

